import {
  CampaignChannel,
  CampaignSortKey,
  CampaignStatus,
  campaignWithOutreachAnalyticsSchema,
} from "@redotech/redo-marketing-common/campaigns/campaign-definition";
import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const getTeamCampaigns = {
  name: "getTeamCampaigns" as const,
  input: z.object({
    includeStats: z.boolean().optional(),
    searchString: z.string().optional(),
    filters: z
      .object({
        channel: z.array(createEnum(CampaignChannel)).optional(),
        status: z.array(createEnum(CampaignStatus)).optional(),
        dateRange: z
          .object({
            startDate: z.string().optional(),
            endDate: z.string().optional(),
          })
          .optional(),
      })
      .optional(),
    sort: z
      .object({
        key: createEnum(CampaignSortKey),
        direction: createEnum(SortDirection),
      })
      .optional(),
    page: z.optional(z.number().positive().int()),
    pageSize: z.optional(z.number().positive().int()),
  }),
  output: z.object({
    campaigns: z.array(campaignWithOutreachAnalyticsSchema),
    totalCount: z.number().int(),
  }),
};
